export function findRoots(element?: Element | ShadowRoot | null) {
    if (!element) {
        return [];
    }
    const list: (Document | ShadowRoot)[] = []
    for (const el of [element, ...element.querySelectorAll('*')]) {
        if ('shadowRoot' in el && !!el.shadowRoot) {
            list.push(el.shadowRoot);
            list.push(...findRoots(el.shadowRoot));
        }
    }
    return list
}

export function getSlot(element: Element, slot: string) {
    let span = element.querySelector(`[slot="${slot}"]`) as HTMLSpanElement;
    if (!span) {
        span = document.createElement("span");
        span.slot = slot;
        element.appendChild(span);
    }
    return span;
}

export async function closeOnBackdropClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Close the dialog when clicking on the background
    if (target instanceof HTMLDialogElement && target.hasAttribute('open')) {
        const rect = target.getBoundingClientRect()
        // Check if the click is outside the dialog content
        if (event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom) {
            return; // Click is inside the dialog content, do not close
        }
        event.preventDefault();
        event.stopPropagation();
        const closeButton = target.querySelector('button') as HTMLButtonElement | null;
        if (closeButton) {
            // Focus the close button before closing the dialog
            // This is to ensure that the dialog closes properly in Chrome (jumps when migrating from the toplayer to its normal place)
            closeButton.focus();
            await Promise.resolve()
            //closeButton.click();
            target.close();
        } else {
            target.close();
        }
    }
}
